import { Alert, Skeleton } from "@norican/react";

import { AppShell } from "@/components/app-shell";
import { CardView } from "@/features/card/card-view";
import { apiStatus, useMyCard } from "@/lib/api";

const ERROR_COPY: Record<number, string> = {
  404: "There is no directory profile for your account, so no card can be generated. Contact the IT helpdesk.",
  503: "The directory is not reachable right now. Try again in a moment.",
};

/** `/home` — the signed-in employee's own card. */
export function MyCardPage() {
  const { data: card, isLoading, error } = useMyCard();

  return (
    <AppShell>
      {isLoading && (
        <div className="flex flex-col gap-8">
          <div className="flex items-center gap-4">
            <Skeleton className="size-16 rounded-full" />
            <div className="flex flex-col gap-2">
              <Skeleton className="h-7 w-56" />
              <Skeleton className="h-4 w-40" />
            </div>
          </div>
          <Skeleton className="aspect-[85/55] w-full max-w-[560px] rounded-xl" />
        </div>
      )}
      {error && (
        <Alert tone="danger" title="Your card is not available">
          {ERROR_COPY[apiStatus(error) ?? 0] ?? "Something went wrong while loading your card."}
        </Alert>
      )}
      {card && <CardView card={card} photoUrl="/api/card/me/photo" owner="me" />}
    </AppShell>
  );
}
